<template>
  <div class="pay-success-container">
    <div class="pay-success-card">
      <div class="pay-success-icon-box">
        <i class="el-icon-circle-check pay-success-icon"></i>
      </div>
      <div class="pay-success-title">支付成功</div>
      <div class="pay-success-desc">感谢您的购买，订单已成功支付！</div>
      <div class="pay-success-info">
        <div class="pay-success-info-row">
          <span class="pay-success-label">订单编号：</span>
          <span class="pay-success-value">{{ product.name }}</span>
        </div>
        <div class="pay-success-info-row">
          <span class="pay-success-label">商品名称：</span>
          <span class="pay-success-value">{{ product.name }}</span>
        </div>
        <div class="pay-success-info-row">
          <span class="pay-success-label">CAS号：</span>
          <span class="pay-success-value">{{ product.cas }}</span>
        </div>
        <div class="pay-success-info-row">
          <span class="pay-success-label">商品价格：</span>
          <span class="pay-success-value">￥{{ product.price }}</span>
        </div>
        <div class="pay-success-info-row">
          <span class="pay-success-label">商品数量：</span>
          <span class="pay-success-value">{{ product.quantity }}</span>
        </div>
        <div class="pay-success-info-row">
          <span class="pay-success-label">总金额：</span>
          <span class="pay-success-value pay-success-total">￥{{ product.total }}</span>
        </div>
      </div>
      <div class="pay-success-actions">
        <el-button type="primary" size="medium" @click="goOrder">查看订单</el-button>
        <el-button size="medium" @click="goHome">返回商城</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { get_order_by_orderid, get_order_by_orderno } from "@/api/modules/user";
export default {
  name: 'PaySuccess',
  data() {
    return {
      order_id: this.$route.query.order_id,
      order_no: this.$route.query.order_no,
      product: {
        name: '对羟基苯甲酸甲酯',
        cas: '99-76-3',
        price: '120.00',
        quantity: 2,
        total: '240.00',
      },
    };
  },
  created() {
    if (this.order_id) {
      this.getOrderInfo();
    } else {
      this.getOrderInfoByNo();
    }
  },
  methods: {
    getOrderInfo() {
      get_order_by_orderid(this.order_id).then((res) => {
        this.product = res.data.data;
      });
    },
    getOrderInfoByNo() {
      get_order_by_orderno(this.order_no).then((res) => {
        this.product = res.data.data;
      });
    },
    goOrder() {
      this.$router.push('/user/purchase/order');
    },
    goHome() {
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
.pay-success-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fbff 0%, #eaf3ff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.pay-success-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(64,158,255,0.12), 0 2px 8px rgba(0,0,0,0.06);
  padding: 48px 40px 32px 40px;
  max-width: 420px;
  width: 100%;
  text-align: center;
  animation: fadeInUp 0.6s cubic-bezier(.23,1.01,.32,1) both;
}
@keyframes fadeInUp {
  0% { opacity: 0; transform: translateY(40px); }
  100% { opacity: 1; transform: none; }
}
.pay-success-icon-box {
  margin-bottom: 18px;
}
.pay-success-icon {
  font-size: 64px;
  color: #67c23a;
  background: #e8f7e0;
  border-radius: 50%;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(103,194,58,0.08);
}
.pay-success-title {
  font-size: 28px;
  font-weight: 700;
  color: #222;
  margin-bottom: 8px;
}
.pay-success-desc {
  font-size: 16px;
  color: #666;
  margin-bottom: 28px;
}
.pay-success-info {
  background: #f7fafd;
  border-radius: 8px;
  padding: 18px 20px 10px 20px;
  margin-bottom: 28px;
  text-align: left;
}
.pay-success-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
}
.pay-success-label {
  color: #7a8599;
}
.pay-success-value {
  font-weight: 500;
  color: #222;
}
.pay-success-total {
  color: #409eff;
  font-size: 18px;
  font-weight: 700;
}
.pay-success-actions {
  margin-top: 18px;
  display: flex;
  justify-content: center;
  gap: 18px;
}
</style>
